import { createLucideIcon } from "lucide-react";

// Custom icons with no lucide equivalent, authored in the lucide 24x24 idiom.
// Original geometry - do not copy FontAwesome Pro path data (license restriction).

/** Circle containing an "H" (hospital symbol). Use with the Icon wrapper's `badge` prop for the filled variant. */
export const HospitalSymbol = createLucideIcon("HospitalSymbol", [
	["circle", { cx: "12", cy: "12", r: "10", key: "circle" }],
	["path", { d: "M8.5 7v10", key: "left" }],
	["path", { d: "M15.5 7v10", key: "right" }],
	["path", { d: "M8.5 12h7", key: "bar" }],
]);

/** Rounded square containing an "H". Use with the Icon wrapper's `badge` prop for the filled variant. */
export const HSquare = createLucideIcon("HSquare", [
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "square" }],
	["path", { d: "M8.5 7v10", key: "left" }],
	["path", { d: "M15.5 7v10", key: "right" }],
	["path", { d: "M8.5 12h7", key: "bar" }],
]);

/** Circle outline with its left half solid: "partially completed" (FontAwesome's `adjust`). */
export const HalfCircle = createLucideIcon("HalfCircle", [
	["circle", { cx: "12", cy: "12", r: "10", key: "circle" }],
	["path", { d: "M12 2a10 10 0 0 0 0 20z", fill: "currentColor", key: "half" }],
]);
